import { Appointment, AppointmentType } from '@uplift/api';
import { L10NShape } from '@uplift/services';


export const getSessionTitle = (l10n: L10NShape, appointment: Appointment, isFirstSession?: boolean) => {
  if (appointment.type === AppointmentType.psychiatry) {
    if (isFirstSession) {
      return l10n.appointments.type.psychConsultation;
    }
    return l10n.appointments.type.medicationManagement;
  }
  return l10n.appointments.type[appointment.type];
};
